import { PureRestRequest } from '@mihanizm56/fetch-api';
import { makeRequestConfig } from './make-request-config';
export var loadConfigFileRequest = function (url) {
    return new PureRestRequest().getRequest(makeRequestConfig(url));
};
